import {
  ExpenseMainType,
  ExpenseSubType,
  PaymentMethod,
} from "../../../api/settlement";

const expenseTypeMap: { [key: string]: string } = {
  TAX_PUBLIC: "[1]세금과공과",
  RABBIT_PURCHASE: "[2]래빗매입",
  LABOR: "[3]인건비",
  RENT_MANAGEMENT: "[4]임차료및관리비",
  SALARY: "[5]급여",
  DRINK_PURCHASE: "[6]주류음료매입",
  TAX_LABOR_BOOK: "[7]세금노무기장",
  MARKETING: "[8]광고마케팅비",
  INSURANCE_COMM: "[9]보험료및통신비",
  SUPPLIES_RENTAL: "[10]비품및렌탈",
  ETC: "[11]기타",
  INTERIOR: "[12]인테리어",
  // [1]세금과공과
  TAX: "[1-1]세금",
  PUBLIC_CHARGE: "[1-2]공과",
  // [3]인건비
  DEALER: "[3-1]딜러",
  COUNTER: "[3-2]카운터",
  FLOOR: "[3-3]플로어",
  // [4]임차료 및 관리비
  RENT: "[4-1]임차료",
  MANAGEMENT_FEE: "[4-2]관리비",
  // [9]보험료 및 통신비
  INSURANCE: "[9-1]보험료",
  COMMUNICATION: "[9-2]통신비",
};

export const getExpenseTypeText = (logType: string) => {
  return expenseTypeMap[logType] || logType;
};

export const getExpenseTypeTextNotCode = (logType: string) => {
  const text = expenseTypeMap[logType] || logType;
  return text?.replace(/^\[[^\]]+\]/, "");
};

const paymentLabelMap = new Map<PaymentMethod, string>([
  [PaymentMethod.CASH, "현금"],
  [PaymentMethod.CARD, "카드"],
  [PaymentMethod.BANK_TRANSFER, "계좌이체"],
  [PaymentMethod.DISCOUNT, "할인"],
  [PaymentMethod.SEED, "크레딧"],
  [PaymentMethod.POINTS, "매장이용권"],
]);

export const getPayTypeText = (value: PaymentMethod) => {
  return paymentLabelMap.get(value);
};

export const formatLogType = (logType: string) => {
  const logTypeMap: { [key: string]: string } = {
    CREATE: "발행",
    MARKETING_CREATE: "발행",
    WITHDRAW: "대회사용",
    PUB_USE: "지급",
    PUB_WITHDRAW: "회수",
    USER_USE: "사용",
    PUB_USE_CANCEL: "지급 취소",
    USER_USE_CANCEL: "사용 취소",
    PUB_TO_USER: "펍에서 유저 수동 지급",
    USER_TO_PUB: "본방회수",
    ISSUED: "발행",
    RECOVERED: "회수",
    USER_CREATE_CANCEL: "유저 래빗 발행 취소",
    USER_CREATE: "유저 래빗 발행",
    TOURNAMENT_REFUND: "시상대기 환급",
    ADMIN_TOURNAMENT_REWARD: "토너먼트 상금 지급 (본사)",
    ADMIN_TOURNAMENT_REFUND: "토너먼트 상금 지급 취소 (본사)",
    RESERVATION_WITHDRAW: "사용 (예약)",
    RESERVATION_WITHDRAW_CANCEL: "사용 취소 (예약)",
    ADMIN_TOURNAMENT_RESULT: "토너먼트 상금 지급 (본사)",
    ADMIN_TOURNAMENT_RESULT_CANCEL: "토너먼트 상금 지급 취소 (본사)",
    REWARDED: "상금 지급",
    REWARD_CANCELLED: "상금 지급 취소",
    BOUNTY: "바운티 지급",
    RESERVATION_DISCOUNT: "예약 할인",
    RESERVATION_DISCOUNT_CANCEL: "예약 할인 취소",
    PUB_TICKET_BUY: "티켓 교환",
    PUB_TICKET_REFUND: "티켓 환불",
    USER_TICKET_BUY: "유저 티켓 교환",
    USER_TICKET_BUY_CANCEL: "유저 티켓 교환 취소",
    DEPOSIT: "디파짓",
    DEPOSIT_CANCEL: "디파짓 취소",
    PROMOTION: "프로모션",
    PROMOTION_CANCEL: "프로모션 취소",
  };

  return logTypeMap[logType] || logType;
};

export const formatMileageLogType = (type: string): string => {
  switch (type) {
    case "CASH":
      return "현금";
    case "BANK":
      return "계좌이체";
    case "CARD":
      return "카드";
    case "BUY":
      return "구매(차감)";
    case "CASH_CANCEL":
      return "현금취소";
    case "BANK_CANCEL":
      return "계좌이체취소";
    case "CARD_CANCEL":
      return "카드취소";
    case "BUY_CANCEL":
      return "환불(지급)";
    case "MANUAL_CHARGE":
      return "수동지급";
    case "MANUAL_CHARGE_CANCEL":
      return "수동지급취소";
    case "EXPIRES":
      return "소멸";
    default:
      return "";
  }
};

export const formatMileageLogUnit = (type: string): string => {
  switch (type) {
    case "CASH":
      return "";
    case "BANK":
      return "";
    case "CARD":
      return "";
    case "BUY":
      return "-";
    case "CASH_CANCEL":
      return "-";
    case "BANK_CANCEL":
      return "-";
    case "CARD_CANCEL":
      return "-";
    case "BUY_CANCEL":
      return "";
    case "MANUAL_CHARGE":
      return "";
    case "MANUAL_CHARGE_CANCEL":
      return "-";
    case "EXPIRES":
      return "-";
    default:
      return "";
  }
};

// 서브타입 정렬
export const EXPENSE_SUB_ORDER: Record<ExpenseSubType, number> = {
  [ExpenseSubType.TAX]: 1,
  [ExpenseSubType.PUBLIC_CHARGE]: 2,

  [ExpenseSubType.DEALER]: 3,
  [ExpenseSubType.COUNTER]: 4,
  [ExpenseSubType.FLOOR]: 5,

  [ExpenseSubType.RENT]: 6,
  [ExpenseSubType.MANAGEMENT_FEE]: 7,

  [ExpenseSubType.INSURANCE]: 8,
  [ExpenseSubType.COMMUNICATION]: 9,
};

// 지출 정렬 순서
export const expenseTypeOrder: Record<ExpenseMainType, number> = {
  [ExpenseMainType.TAX_PUBLIC]: 1,
  [ExpenseMainType.RABBIT_PURCHASE]: 2,
  [ExpenseMainType.LABOR]: 3,
  [ExpenseMainType.RENT_MANAGEMENT]: 4,
  [ExpenseMainType.SALARY]: 5,
  [ExpenseMainType.DRINK_PURCHASE]: 6,
  [ExpenseMainType.TAX_LABOR_BOOK]: 7,
  [ExpenseMainType.MARKETING]: 8,
  [ExpenseMainType.INSURANCE_COMM]: 9,
  [ExpenseMainType.SUPPLIES_RENTAL]: 10,
  [ExpenseMainType.ETC]: 11,
  [ExpenseMainType.INTERIOR]: 12,
};
